import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class SigninEventAttendeeService {
  private http = inject(HttpClient);

  list(
    urlParams: { company_id: string | number; event_id: string | number },
    apiParams: Record<string, any> = {}
  ): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl(urlParams), {
      params: this.toHttpParams(apiParams),
    });
  }

  create(
    body: any,
    urlParams: { company_id: string | number; event_id: string | number },
    apiParams: Record<string, any> = {}
  ): Observable<any> {
    return this.http.post<any>(this.baseUrl(urlParams), body, {
      params: this.toHttpParams(apiParams),
    });
  }

  update(
    id: string | number,
    body: any,
    urlParams: { company_id: string | number; event_id: string | number },
    apiParams: Record<string, any> = {}
  ): Observable<any> {
    return this.http.put<any>(`${this.baseUrl(urlParams)}/${id}`, body, {
      params: this.toHttpParams(apiParams),
    });
  }

  private baseUrl(urlParams: { company_id: string | number; event_id: string | number }): string {
    return `${environment.apiUrl}/api/companies/${urlParams.company_id}/events/${urlParams.event_id}/attendees`;
  }

  private toHttpParams(obj: Record<string, any>): HttpParams {
    let params = new HttpParams();
    for (const key of Object.keys(obj)) {
      const val = obj[key];
      if (val !== null && val !== undefined && val !== '') {
        params = params.append(key, String(val));
      }
    }
    return params;
  }
}
